export default __webpack_public_path__ + "static/article_tips_to_help_you_become_a_saver-c80ea2ff7de3fae1ee2900da10f0ba07.webp";